import { lazy } from "react";
// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const PlanTasksChartsViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-plantaskschartsview" */ "./PlanTasksChartsView")).then((page)=>{
        return {
            default: page.PlanTasksChartsView
        };
    });
export const LazyPlanTasksChartsView = /*#__PURE__*/ lazy(PlanTasksChartsViewLazyLoader);
